import TRANSLATIONS from './json/fr_CH_translations.json'

const TRANSLATIONS_FR_CH = {
  'checkout_shipping.pOBoxWarningText': `${window.appConfig?.pOBoxWarningText}`,
  'shopping_cart_details.hoverToZoom': 'Survolez l’image pour zoomer',
  'shopping_cart_details.tapToZoom': 'Appuyez pour zoomer',
  'coupon_code.page_link': 'noOffersPagePresent',
  'order_summary.your_promos' : 'Vos codes promo',
  'shopping_cart_details.editImprint': 'Modifier l’impression',
  'shopping_cart_details.clickToZoom': 'Cliquez sur l’image pour zoomer',
  'shopping_cart_details.ships_within_msg': 'Expédition sous [X] jours ouvrés',
  'shopping_cart_details.item_total': 'Total du produit :',
  'shopping_cart_details.each': '[X] l’unité',
  'shopping_cart_details.see_more': 'Voir Plus',
  'shopping_cart_details.see_less': 'Voir Moins',
  'order_confirmation.cartToOrderFailureMessage' : 'Votre commande sera confirmée au plus vite.',
  'checkout_payment.paymentErrorTitle': 'Erreur lors du paiement',
  'checkout_payment.paymentErrorMessage': 'Veuillez saisir à nouveau vos informations de paiement. Si le problème persiste, contactez notre service client.',
  'checkout_payment.empty_string': '',
  'checkout_payment.credit_debit': 'Crédit/Débit',
  'checkout_payment.card_number': 'Numéro de carte*',
  'checkout_payment.expiration_mm_yy': 'MM/AA*',
  'checkout_payment.cvv': 'CVV*',
  'checkout_payment.name_on_card': 'Nom sur la carte*',
  'checkout_payment.check_cc_try_again': 'Veuillez vérifier le numéro de carte et réessayer.',
  'checkout_payment.check_date_try_again': 'Veuillez vérifier la date et réessayer.',
  'checkout_payment.check_code_try_again': 'Veuillez vérifier le code et réessayer.',
  'checkout_payment.enter_holder_name': 'Saisissez le nom sur la carte.',
  'checkout_payment.enter_cc_number': 'Saisissez le numéro de carte de crédit.',
  'checkout_payment.enter_expiration_date': 'Saisissez la date d’expiration',
  'checkout_payment.enter_cvv': 'Saisissez le code de sécurité.',
  'checkout_payment.paypal_pay_later': 'Paiement en 4 fois avec PayPal',
  'checkout_payment.continue_will_open_paypal_account_msg': 'En choisissant de continuer, vous accéderez à votre compte PayPal.',
  'checkout_payment.continue_will_open_google_pay_account_msg': 'En continuant, vous accéderez à Google Pay.',
  'checkout_payment.paypal': 'PayPal',
  'checkout_payment.pay_by_invoice': 'Paiement sur facture',
  'checkout_payment.buy_now_pay_later_info_msg': 'Achetez maintenant et payez plus tard ! Nous vous enverrons une facture dès que votre commande sera en chemin.',
  'checkout_payment.learn_more': 'En savoir plus',
  'checkout_payment.payment_due_late_fee_info_msg': 'Le montant doit être réglé à réception de la facture. Tout retard de paiement peut entraîner des frais de pénalité.',
  'shopping_cart_details.unit': 'unité',
  'shopping_cart_details.editModalSaving': `Vous économisez`,
  'shopping_cart_details.editModalMin_QtyWarning': `Malheureusement, ce nombre est inférieur à la quantité minimale de commande. Pour passer une plus petite commande, merci de nous contacter.`,
  'shopping_cart_details.editModalMax_QtyWarning': `Malheureusement, ce nombre dépasse la quantité maximale de commande. Pour passer une commande plus volumineuse, merci de nous contacter.`,
  'product_details.price':'Prix',
  'product_details.edit_quantity':'Modifier la quantité',
  'myaccount_order_details.seeDetails': 'Afficher les détails',
  'myaccount_order_details.viewOrderDetails': 'Voir les détails de la commande',
  'myaccount_order_details.payMyInvoice': 'Paiement de factures',
  'myaccount_order_details.buyItAgain': 'Acheter de nouveau',
  'myaccount_order_details.viewImprint': 'Voir l’impression',
  'myaccount_order_details.viewArtwork': 'Voir le graphisme',
  'myaccount_order_details.productDetails': 'Détails du produit',
  'myaccount_order_details.orders': 'commandes',
  'my_account_order_details.shipping_and_billing_addresses': 'Adresses de livraison et de facturation',
  'my_account_order_details.log_in_to_view' : 'Connectez-vous pour plus de détails',
  'error.use_of_old_password': 'Le mot de passe doit être différent des cinq précédents.',
  'order_confirmation.postCheckout_signIn':`Connectez-vous pour plus d’avantages`,
  'order_confirmation.postCheckout_accountCreation':'Inscrivez-vous pour plus d’avantages',
  'order_confirmation.postCheckout_trackOrder':'Suivez facilement votre commande',
  'order_confirmation.would_you_like_to':'Profitez de réductions spéciales et recevez des échantillons gratuits lorsque vous vous inscrivez aux offres par e-mail et par téléphone de Pens.com.',
  'order_confirmation.sign_up.contact_agreement1':'Oui',
  'order_confirmation.sign_up.contact_agreement2':', j’adore les offres',
  'order_confirmation.sign_up.contact_disagreement1':'Non',
  'order_confirmation.sign_up.contact_disagreement2':', merci',
  'create_account.title':'Créez votre compte',
  'order_confirmation.sign_in.title':'Connectez-vous à votre compte',
  'order_confirmation.my_acc.title':'Mon compte',
  'order_confirmation.addPassword':'Saisissez un mot de passe :',
  'order_confirmation.accountCreated':'Compte créé',
  'myaccount_address_list.shippingAddresses': 'Adresse de livraison',
  'myaccount_address_list.billingAddresses': 'Adresse de facturation',
  'myaccount_address_list.defaultAddress': 'Adresse par défaut',
  'myaccount_address_list.setDefault': 'Définir l’adresse par défaut',
  'myaccount_delete_address.delete_confirmation': 'Confirmation de suppression',
  'myaccount_delete_address.confirmation_message': 'Voulez-vous vraiment supprimer cette adresse ?',
  'myaccount_delete_address.delete_address': 'Supprimer l’adresse',
  'myaccount_delete_address.delete': 'Supprimer',
  'myaccount_error_new_password.complexity':"Le nouveau mot de passe doit inclure : un chiffre, un caractère spécial [!#$%&'*+-/=?^_`{|}~.@], une lettre majuscule et une minuscule.",
  'myaccount_error_confirm_password.complexity':"Le mot de passe confirmé doit inclure : un chiffre, un caractère spécial [!#$%&'*+-/=?^_`{|}~.@], une lettre majuscule et une minuscule.",
  'myaccount_error_new_password.common_password':'Le nouveau mot de passe ne peut pas être identique à votre adresse e-mail.',
  'myaccount_error_confirm_password.common_password':'Le mot de passe confirmé ne peut pas être identique à votre adresse e-mail.',
  'myaccount.change_personal_information.change_password_info' : 'Tous les appareils actifs seront déconnectés.',
  'validation.password_validation_heading' : 'Le mot de passe doit inclure :',
  'validation.password_validation_uppercase' : 'Un caractère majuscule',
  'validation.password_validation_lowercase' : 'Un caractère minuscule',
  'validation.password_validation_symbol' : 'Un caractère spécial',
  'validation.password_validation_number' : 'Un nombre',
  'validation.password_validation_length' : '8 caractères minimum',
  'validation.password_validation_match' : 'Les mots de passe doivent être identiques',
  'validation.password_min_characters': 'Le mot de passe doit contenir au moins 8 caractères.',
  'myaccount_password_settings.heading' : 'Paramètres du mot de passe',
  'myaccount_password_settings.newPassword' : 'Nouveau mot de passe',
  'myaccount_password_settings.confirmPassword' : 'Confirmer le mot de passe',
  'myaccount_password_settings.updatePassword' : 'Modifier le mot de passe',
  'myaccount_password_settings.createPassword' : 'Créer un mot de passe',
  'myaccount_password_settings.use_of_old_password': 'Le mot de passe doit être différent des cinq précédents.',
  'order_details.payment_mode_apple_pay' : 'Apple Pay',
  'order_details.payment_mode_google_pay' : 'Google Pay',
  'order_details.payment_mode_ideal' : 'iDEAL',
  'order_details.payment_mode_bancontact' : 'Bancontact',
  'order_details.payment_mode_klarna' : 'Klarna',
  'dashboard.greeting':'Bonjour,',
  'myaccount_personal_info.save_changes' : 'Enregistrer',
  'myaccount_personal_info.cancel' : 'Annuler',
  'myaccount_personal_info.name_title' : 'Nom',
  'myaccount_personal_info.password_title' : 'Mot de passe',
  'myaccount_personal_info.add_name' : 'Ajouter un nom',
  'myaccount_personal_info.edit_name' : 'Modifier le nom',
  'myaccount_personal_info.name_updated' : 'Nom modifié.',
  'myaccount.something_went_wrong': 'Une erreur est survenue. Veuillez réessayer.',
  'checkout.reorder.buy_it_again':'Acheter de nouveau',
  'checkout.reorder.purchased':'Date d’achat',
  'checkout.reorder.last_qty':'Dernière quantité commandée',
  'checkout.reorder.ships_within_msg':'Expédition sous [X] jours ouvrés',
  'checkout.reorder.add_to_cart': 'Ajouter au panier',
  'checkout_payment.klarna_text' : 'Klarna',
  'checkout_payment.klarna_continue_text': 'En choisissant de continuer, vous accéderez à votre compte Klarna.',
  'shopping_cart_details.add_accessory': 'Ajouter un accessoire',
  'shopping_bag.expired_discount_coupon':'Le code promo que vous avez saisi a expiré. Veuillez saisir un autre code promo.',
  'shopping_bag.invalid_discount_coupon':'Le code promo que vous avez saisi n’est pas valide. Veuillez saisir un autre code promo.',
  'order_summary.oops_error': "Oups ! Il semble qu'une erreur s'est produite de notre côté. Veuillez réessayer.",
  'order_summary.one_promo_at_a_time': 'Un seul code promo peut être utilisé à la fois.',
  'order_summary.code_applied': 'Code appliqué',
  'order_summary.change_promo': 'Changer de code promo',
  'order_summary.your_promo_code': 'Vos codes promo',
  'order_summary.no_items_eligible': "Aucun des articles dans votre panier n'est éligible pour ce code promo.",
  'shopping_cart_details.add_amount': 'Dépensez [X] supplémentaires pour débloquer l’offre',
  'order_details.production_time_begin_msg': '*Le temps de production démarre à partir de la confirmation de la commande et de l’approbation d’éventuels visuels.',
  'order_details.reorder_tat': 'Produits de nouveau commandés expédiés sous X jours ouvrés*',
  'gdpr.heading' : 'Compte créé. Bienvenue !',
  'gdpr.subheading' : 'Votre compte a été créé avec l’adresse e-mail :',
  'gdpr.promotion': 'Profitez de réductions spéciales et recevez des échantillons gratuits lorsque vous vous inscrivez aux offres par e-mail de Pens.com.',
  'gdpr.yesDeal' : 'Oui, j’adore les bonnes affaires',
  'gdpr.noDeal' : 'Non, merci',
  'gdpr.button' : 'Continuez',
  'new_activation.head' : 'Consultez vos e-mails.',
  'new_activation.sub_head' : 'Bonjour',
  'new_activation.main_body1' : 'Merci pour votre inscription sur Pens.com',
  'new_activation.main_body2' : 'Un lien d’activation sera envoyé à votre adresse mail enregistrée',
  'new_activation.main_body3' : 'Vous ne pourrez pas vous connecter tant que votre compte n’aura pas été activé. S’il vous plaît, cliquez sur le lien d’activation pour activer votre compte.',
  'myaccount_personal_info.password_not_set' : 'Aucun mot de passe n’a été défini pour ce compte. Veuillez',
  'myaccount_personal_info.click_here' : 'cliquer ici',
  'myaccount_personal_info.to_reset_password' : 'pour créer un nouveau mot de passe.',
  'myaccount_personal_info.note' : 'Remarque : en poursuivant, vous serez déconnecté de toutes les sessions actives.',
  'customer_service.would_you_like_to': "Souhaitez-vous recevoir les offres de Pens.com par e-mail et par téléphone et recevoir également des échantillons gratuits ?",
  'oos.item_out_of_stock': 'Ce produit est actuellement épuisé.',
  'oos.view_similar': 'Voir d’autres produits similaires',
  'oos.similar_products': 'Produits similaires',
  'oos.remove_out_of_stock_items': 'Vous devez retirer les articles épuisés de votre panier.',
  'oos.one_or_more_items_removed_from_cart': 'Un ou plusieurs formats sont épuisés et ont été retirés de ce produit.',
  'oos.go_back_to_review': 'Revenez au panier pour vérifier',
  'oos.go_back_to_remove': 'Revenez au panier pour supprimer l’article',
  'oos.out_of_stock': 'Épuisé',
  'moq.lineItem_warning': 'La quantité sélectionnée est inférieure au minimum requis pour cet article.',
  'moq.edit_qantity_link_text': 'Veuillez sélectionner une nouvelle quantité.',
  'moq.cart_level_warning': 'Veuillez modifier la quantité pour passer au paiement.',
  'moq.go_back_to_cart': 'Revenez au panier pour sélectionner une nouvelle quantité de commande',
  ...TRANSLATIONS,
  'customer_service.would_you_like_to': "Souhaitez-vous recevoir les offres de Pens.com par e-mail et par téléphone et recevoir également des échantillons gratuits ?",
  'import_charge_title':'Taxes à l’importation',
  'import_charge_description': "Les récentes taxes à l'importation ont affecté le prix de nos produits. Nous mettons tout en œuvre pour limiter l’impact de l’augmentation des prix pour nos clients."
};
export default TRANSLATIONS_FR_CH;